/* eslint-disable no-unused-vars */
import React from "react";
import PropTypes from "prop-types";

import { useGridApiRef } from "@mui/x-data-grid-premium";
import { Typography } from "@mui/material";
import { Translate } from "orion-components/i18n";
import CustomizedDataGridPremium from "./components/CustomizedDataGridPremium";

const propTypes = {
	columns: PropTypes.array,
	rows: PropTypes.array,
	initialState: PropTypes.object,
	customStyles: PropTypes.object,
	columnHeaderHeight: PropTypes.number,
	disableColumnReorder: PropTypes.bool,
	onRowClick: PropTypes.func,
	rowGroupingModel: PropTypes.array,
	groupingColDef: PropTypes.object,
	defaultGroupingExpansionDepth: PropTypes.number,
	getCellClassName: PropTypes.func,
	checkboxSelection: PropTypes.bool,
	isRowSelectable: PropTypes.func,
	rowSelectionModel: PropTypes.array,
	onRowSelectionModelChange: PropTypes.func,
	enableFilters: PropTypes.bool,
	filterModel: PropTypes.object,
	onFilterModelChange: PropTypes.func,
	slotProps: PropTypes.object
};

const defaultProps = {
	columns: [],
	rows: [],
	initialState: {},
	customStyles: {},
	columnHeaderHeight: 48,
	disableColumnReorder: true,
	onRowClick: () => {},
	rowGroupingModel: [],
	groupingColDef: {},
	defaultGroupingExpansionDepth: -1,
	getCellClassName: () => {},
	slots: {},
	checkboxSelection: false,
	isRowSelectable: () => true,
	rowSelectionModel: [],
	onRowSelectionModelChange: () => {},
	slotProps: {}
};

const CBDataGrid = ({
	columns,
	rows,
	initialState,
	customStyles,
	columnHeaderHeight,
	disableColumnReorder, // restricts the ability to reorder columns.
	onRowClick,
	rowGroupingModel, // prop responsible for row grouping.
	groupingColDef, // prop applied for the grouping column.
	defaultGroupingExpansionDepth, // prop responsible for row grouping being expanded on load.
	getCellClassName, // prop to add custom css classes.,
	slots, // prop applied to override grid overlay.,
	customNoRowsMessage,
	getRowClassName,
	customClasses,
	onSortModelChange,
	sortModel,
	sortingMode,
	checkboxSelection,
	isRowSelectable,
	rowSelectionModel,
	onRowSelectionModelChange,
	enableFilters,
	filterModel,
	onFilterModelChange,
	slotProps
}) => {
	const apiRef = useGridApiRef();

	const getDefaultNoRowsOverlay = () => {
		return (
			<Typography
				style={{
					padding: "24px 0px",
					color: "#B5B9BE",
					display: "inherit",
					border: "1px solid #707070",
					borderRadius: "10px",
					height: "143px",
					margin: "23px 48px",
					// display: "flex",
					alignItems: "center",
					width: "95%"
				}}
				align="center"
				variant="caption"
				sx={{ color: "#98999D" }}
			>
				{customNoRowsMessage?.length > 0 ? (
					<div style={{ width: "100%", fontSize: 14, color: "#B4B8BC" }}>{customNoRowsMessage}</div>
				) : (
					<Translate
						value="global.dock.notifications.main.noAlarmsOrNotifications"
						style={{ width: "100%", fontSize: 14, color: "#B4B8BC" }}
					/>
				)}
			</Typography>
		);
	};

	return (
		<CustomizedDataGridPremium
			apiRef={apiRef}
			columns={columns}
			rows={rows}
			initialState={initialState}
			disableColumnMenu
			columnHeaderHeight={columnHeaderHeight}
			disableColumnReorder={disableColumnReorder}
			rowGroupingModel={rowGroupingModel}
			groupingColDef={groupingColDef}
			defaultGroupingExpansionDepth={defaultGroupingExpansionDepth}
			sx={customStyles}
			customStyles={customStyles}
			onRowClick={onRowClick}
			getCellClassName={getCellClassName}
			slots={{
				noRowsOverlay: getDefaultNoRowsOverlay,
				...slots
			}}
			slotProps={slotProps}
			getRowClassName={getRowClassName}
			customClasses={customClasses}
			onSortModelChange={onSortModelChange}
			sortModel={sortModel}
			sortingMode={sortingMode}
			checkboxSelection={checkboxSelection}
			isRowSelectable={isRowSelectable}
			rowSelectionModel={rowSelectionModel}
			onRowSelectionModelChange={onRowSelectionModelChange}
			{...(enableFilters && {
				filterModel,
				onFilterModelChange
			})}
		/>
	);
};

CBDataGrid.propTypes = propTypes;
CBDataGrid.defaultProps = defaultProps;

export default CBDataGrid;
